import React, { Component } from "react";
import { request } from "../../../../config";
import { translate } from "react-i18next";
import AlertPopup from "../../../../copms/AlertPopup/AlertPopup";
import deposit1 from "../../img/deposit1.png";
import deposit2 from "../../img/deposit2.png";
// import "./DepositOrder2.scss";

class DepositOrder extends Component {
  state = {
    products: [],
    accounts: [],
    interestAccounts: [],
    terms: [],
    selectedProductIndex: -1,
    selectedAccountIndex: -1,
    selectedInterestAccountIndex: -1,
    selectedPeriod: null,
    selectedDepositIndex: -1,
    amount: "",
    isLoading: false,
    isCalculating: false,
    result: null,
    open: false,
    popupType: "error",
    title: "",
    feedbackMessage: "",
    amountText: "",
    termText: "",
    rateText: "",
    maxTerm: "",
    currencies: "",
  };

  componentDidMount() {
    this.productList();
  }

  requestBody = (extra = {}) => {
    const customerType =
      localStorage.getItem("compId") === null ? "Individual" : "Juridical";
    return {
      custId: localStorage.getItem("custId"),
      token: localStorage.getItem("token"),
      lang: (localStorage.getItem("i18nextLng") || "az").toUpperCase(),
      ...(customerType === "Juridical"
        ? { compId: localStorage.getItem("compId") }
        : {}),
      ...extra,
    };
  };

  handleResponse = (response, onSuccess) => {
    if (response.status?.statusCode === 1) {
      onSuccess(response);
      return;
    }
    if (response.status?.statusCode === 200) {
      if (this.props.logout) this.props.logout();
      return;
    }
    this.setState({
      open: true,
      popupType: "error",
      title: this.props.t("an error occurred"),
      feedbackMessage: this.props.t(response.status?.statusCode),
      isLoading: false,
      isCalculating: false,
    });
  };

  closeFunction = () => this.setState({ open: false });

  load = async (endpoint, body, onSuccess) => {
    try {
      const responseText = await fetch(request(endpoint, body)).then(
        (response) => response.text(),
      );
      const JSON = require("true-json-bigint");
      this.handleResponse(JSON.parse(responseText), onSuccess);
    } catch (error) {
      // this.props.history?.push("/technical-break");
    }
  };

  productList = async () => {
    this.setState({ isLoading: true });
    await this.load(
      "deposit/v2/getDepositProductName",
      this.requestBody(),
      (response) => {
        const products = response.products || [];
        this.setState({ products, isLoading: false }, () => {
          const operationId = this.props.location?.state?.oprId;
          const selectedIndex = operationId
            ? products.findIndex(
              (product) => product.productNameId === operationId,
            )
            : 0;
          if (selectedIndex >= 0) this.selectProduct(selectedIndex);
        });
      },
    );
  };

  selectProduct = async (selectedProductIndex) => {
    const product = this.state.products[selectedProductIndex];
    if (!product) return;
    this.setState({
      selectedProductIndex,
      accounts: [],
      interestAccounts: [],
      terms: [],
      selectedAccountIndex: -1,
      selectedInterestAccountIndex: -1,
      selectedPeriod: null,
      selectedDepositIndex: -1,
      result: null,
    });
    await this.load(
      "deposit/getAccountList",
      this.requestBody({ productNameId: product.productNameId }),
      (response) => {
        this.setState({ accounts: response.accountList || [] });
      },
    );
  };

  selectAccount = async (event) => {
    const selectedAccountIndex = Number(event.target.value);
    const account = this.state.accounts[selectedAccountIndex];
    if (!account) return;
    this.setState({
      selectedAccountIndex,
      interestAccounts: [],
      terms: [],
      selectedInterestAccountIndex: -1,
      selectedPeriod: null,
      selectedDepositIndex: -1,
      result: null,
    });
    const productNameId =
      this.state.products[this.state.selectedProductIndex]?.productNameId;
    await this.load(
      "deposit/getAccountPerList",
      this.requestBody({
        productNameId,
        branchId: account.branchId,
        curCode: account.curCode,
      }),
      (response) => {
        this.setState({ interestAccounts: response.accountList || [] });
      },
    );
    await this.load(
      "deposit/getDepositProductInfoById",
      this.requestBody({ productNameId, currency: account.currName }),
      (response) => {
        this.setState({
          terms: response.terms || [],
          amountText: response.amountText || '',
          termText: response.termText || '',
          rateText: response.rateText || '',
          maxTerm: response.maxTerm || '',
          currencies: response.currencies || '',
        });
      },
    );
  };

  selectPeriod = (selectedPeriod) =>
    this.setState({ selectedPeriod, selectedDepositIndex: -1, result: null });

  selectFrequency = (selectedDepositIndex) =>
    this.setState({ selectedDepositIndex, result: null });

  calculate = async () => {
    const {
      amount,
      accounts,
      selectedAccountIndex,
      terms,
      selectedDepositIndex,
      selectedPeriod,
    } = this.state;
    const selectedTerm = terms.find((term) => term.term === selectedPeriod);
    const selectedFrequency = selectedTerm?.frequencies?.[selectedDepositIndex];
    if (
      !amount ||
      Number(amount) < selectedFrequency?.minAmount ||
      Number(amount) > selectedFrequency?.maxAmount ||
      selectedAccountIndex < 0 ||
      !selectedFrequency
    )
      return;
    this.setState({ isCalculating: true });
    await this.load(
      "deposit/calcDepositPercentAmountV1",
      this.requestBody({
        amount,
        accountId: accounts[selectedAccountIndex]?.accountId,
        rate: selectedFrequency.rate,
        term: selectedPeriod,
        depSettProductId: selectedFrequency.depSettProductId,
      }),
      (response) => this.setState({ result: response }),
    );
    this.setState({ isCalculating: false });
  };

  continueDeposit = async () => {
    const {
      amount,
      products,
      accounts,
      interestAccounts,
      selectedProductIndex,
      selectedAccountIndex,
      selectedInterestAccountIndex,
      terms,
      selectedDepositIndex,
      selectedPeriod,
    } = this.state;
    const selectedTerm = terms.find((term) => term.term === selectedPeriod);
    const selectedFrequency = selectedTerm?.frequencies?.[selectedDepositIndex];
    const selectedInterestAccount =
      interestAccounts[selectedInterestAccountIndex];

    if (!selectedFrequency || !selectedInterestAccount) return;

    this.setState({ isCalculating: true });
    await this.load(
      "deposit/openDepositContract",
      this.requestBody({
        amount,
        accountId: accounts[selectedAccountIndex]?.accountId,
        perAccountId: selectedInterestAccount.accountId,
        rate: selectedFrequency.rate,
        term: selectedPeriod,
        productNameId: products[selectedProductIndex]?.productNameId,
        depSettProductId: selectedFrequency.depSettProductId,
      }),
      ({ depositId, documentId, time }) => {
        this.props.history.push("/dashboard/finance/deposits/fatca-contract", {
          request: this.requestBody({ depositId, documentId }),
          time,
        });
      },
    );
    this.setState({ isCalculating: false });
  };

  render() {
    const {
      products,
      accounts,
      interestAccounts,
      terms,
      selectedProductIndex,
      selectedAccountIndex,
      selectedInterestAccountIndex,
      selectedPeriod,
      selectedDepositIndex,
      amount,
      isLoading,
      isCalculating,
      result,
      open,
      popupType,
      title,
      feedbackMessage,
      amountText,
      termText,
      rateText,
      currencies,
    } = this.state;
    let { t, history } = this.props;
    const selectedAccount = accounts[selectedAccountIndex];
    const selectedProduct = products[selectedProductIndex];
    const selectedTerm = terms.find((term) => term.term === selectedPeriod);
    const availableFrequencies = selectedTerm?.frequencies || [];
    const selectedFrequency = availableFrequencies[selectedDepositIndex];
    // const frequencies = terms.flatMap((term) => term.frequencies || []);
    const isYigimDeposit = selectedProduct?.productNameId === 3;
    const depositConditions = terms.length
      ? [
        ...(isYigimDeposit
          ? [
            {
              label: t("Maximum amount"),
              value: amountText,
            },
          ]
          : []),
        {
          label: t("Currencies"),
          value: currencies,
        },
        {
          label: t("period"),
          value: termText,
        },
        {
          label: t("interest rate"),
          value: rateText,
        },
        
      ]
      : [];
    const canCalculate =
      amount &&
      Number(amount) >= selectedFrequency?.minAmount &&
      Number(amount) <= selectedFrequency?.maxAmount &&
      selectedAccountIndex >= 0 &&
      selectedFrequency;

    return (
      <>
        <AlertPopup
          open={open}
          closeFunction={this.closeFunction}
          popupType={popupType}
          title={title}
          feedbackMessage={feedbackMessage}
          closeSuccessFunction={this.closeSuccessFunction}
        />
        <div className="dashboard-header-route">
          <div className="dashboard-header-route-left">
            <button onClick={() => history.goBack()}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z"
                  fill="#2E3131"
                />
              </svg>
            </button>
            <h2>{t("Deposit placement")}</h2>
          </div>
        </div>
        <div className="dashboard-payment-container">
          <div
            className="dashboard-payment-container-data-section"
            style={{ marginTop: "1px", width: "100%" }}
          >
            <form className="dashboard-payment-container-data-section-content">
              <div className="dashboard-payment-container-data-section-content-container">
                {/* <h3 className="dashboard-payment-container-data-section-content-container-title">{t('order info')}</h3> */}

                <div className="deposit-order-preview">
                  <div className="deposit-order-preview__offers">
                    {products.map((product, index) => (
                      <button
                        className={`deposit-order-preview__offer ${index % 2 ? "deposit-order-preview__offer--gold" : ""} ${selectedProductIndex === index ? "deposit-order-preview__offer--selected" : ""}`}
                        key={product.productNameId}
                        type="button"
                        onClick={() => this.selectProduct(index)}
                      >
                        <span
                          className="deposit-order-preview__offer-icon"
                          aria-hidden="true"
                        >
                          {index % 2 ? <img src={deposit2} alt="Deposit" width="104" /> : <img src={deposit1} alt="Deposit" width="104" />}
                        </span>
                        <span className="deposit-order-preview__offer-title">
                          {product.productName}
                        </span>
                        <span className="deposit-order-preview__offer-copy">
                          {product.description}
                        </span>
                      </button>
                    ))}
                    {isLoading && (
                      <span className="deposit-order-preview__loading">
                        {t("Loading")}
                      </span>
                    )}
                  </div>
                  <div className="deposit-order-preview__content">
                    <section>
                      <h1 className="deposit-order-preview__heading">
                        {t("Deposit terms")}
                      </h1>
                      <div className="deposit-order-preview__terms">
                        {depositConditions.length ? (
                          depositConditions.map((condition) => (
                            <div
                              className="deposit-order-preview__term"
                              key={condition.label}
                            >
                              <span>{condition.label}</span>
                              <strong>{condition.value}</strong>
                            </div>
                          ))
                        ) : (
                          <div className="deposit-order-preview__term">
                            <span>{t("Deposit terms")}</span>
                            <strong>-</strong>
                          </div>
                        )}
                      </div>
                    </section>
                    <section>
                      <h2 className="deposit-order-preview__heading">
                        {t("Deposit calculator")}
                      </h2>
                      {result ? (
                        <div className="deposit-order-preview__result">
                          <div className="deposit-order-preview__result-card">
                            <strong className="deposit-order-preview__result-title">
                              {selectedProduct?.productName || t("deposit")}
                            </strong>
                            <p className="deposit-order-preview__result-summary">
                              {amount} {selectedAccount?.currName} 
                              {/* · {selectedTerm?.label} · {selectedFrequency?.rate}% {t("Annual")} */}
                            </p>
                            <div className="deposit-order-preview__result-amounts">
                              <div className="deposit-order-preview__result-amount">
                                <span>{t("Total income")}</span>
                                <strong>{result.percentAmount}</strong>
                                <small>{selectedAccount?.currName}</small>
                              </div>
                              {/* <div className="deposit-order-preview__result-amount">
                                <span>{t("Bonus amount")}</span>
                                <strong>{result.bonusAmount}</strong>
                                <small>{selectedAccount?.currName}</small>
                              </div> */}
                            </div>
                          </div>
                          <div className="deposit-order-preview__result-details">
                            <div><span>{t("Annual interest rate")}</span><strong>{selectedFrequency?.rate}%</strong></div>
                            <div><span>{t("period")}</span><strong>{selectedTerm?.label}</strong></div>
                            <div><span>{t("currency")}</span><strong>{selectedAccount?.currName}</strong></div>
                            {/* <div><span>Faizlərin mədaxil hesabı</span><strong>{selectedInterestAccount?.iban || "-"}</strong></div> */}
                            <div><span>{t("Final amount")}</span><strong>{result.totalAmount} {selectedAccount?.currName}</strong></div>
                          </div>
                          {result.infoMessage && <div className="deposit-order-preview__result-info"><span>i</span><p>{result.infoMessage}</p></div>}
                          <button
                            className="deposit-order-preview__submit deposit-order-preview__result-submit"
                            type="button"
                            disabled={selectedInterestAccountIndex < 0 || isCalculating}
                            onClick={this.continueDeposit}
                          >
                            {isCalculating ? t("Continuing") : t("Confirm")}
                          </button>
                        </div>
                      ) : <><div className="deposit-order-preview__calculator">
                        <div className="deposit-order-preview__grid">
                          <div className="deposit-order-preview__field">
                            <label
                              className="deposit-order-preview__label"
                              htmlFor="payment-method"
                            >
                              {t('Select an account to withdraw funds from')}
                            </label>
                            <select
                              className="deposit-order-preview__input"
                              id="payment-method"
                              value={selectedAccountIndex}
                              onChange={this.selectAccount}
                              disabled={!accounts.length}
                            >
                              <option value={-1}>{t("Choose")}</option>
                              {accounts.map((account, index) => (
                                <option key={index} value={index}>
                                  {account.iban} /{" "}
                                  {account.currentBalance?.toFixed(2)}{" "}
                                  {account.currName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="deposit-order-preview__field">
                            <label
                              className="deposit-order-preview__label"
                              htmlFor="deposit-amount"
                            >
                              {t("Amount")}
                            </label>
                            <input
                              className="deposit-order-preview__input"
                              id="deposit-amount"
                              inputMode="decimal"
                              value={amount}
                              onChange={(event) =>
                                this.setState({
                                  amount: event.target.value.replace(
                                    /[^0-9.]/g,
                                    "",
                                  ),
                                  result: null,
                                })
                              }
                              placeholder={t("Enter")}
                            />
                            {selectedFrequency && (selectedProductIndex === 0 ?
                              (Number(amount) < selectedFrequency.minAmount ||
                                Number(amount) >
                                selectedFrequency.maxAmount) && (
                                <span className="deposit-order-preview__error">
                                  {t("Amount range validation", {
                                    min: selectedFrequency.minAmount,
                                    max: selectedFrequency.maxAmount,
                                  })}
                                </span>
                              ) : (Number(amount) < selectedFrequency.minAmount) && (
                                <span className="deposit-order-preview__error">
                                  {t("Amount range validation for min", {
                                    min: selectedFrequency.minAmount,
                                  })}
                                </span>
                              ))}
                          </div>
                          <div className="deposit-order-preview__field">
                            <label
                              className="deposit-order-preview__label"
                              htmlFor="interest-account"
                            >
                              {t("Interest credit account")}
                            </label>
                            <select
                              className="deposit-order-preview__input"
                              id="interest-account"
                              value={selectedInterestAccountIndex}
                              onChange={(event) =>
                                this.setState({
                                  selectedInterestAccountIndex: Number(
                                    event.target.value,
                                  ),
                                })
                              }
                              disabled={!interestAccounts.length}
                            >
                              <option value={-1}>{t("Choose")}</option>
                              {interestAccounts.map((account, index) => (
                                <option key={index} value={index}>
                                  {account.iban} /{" "}
                                  {account.currentBalance?.toFixed(2)}{" "}
                                  {account.currName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="deposit-order-preview__grid">
                          <div className="deposit-order-preview__choice-box">
                            <span className="deposit-order-preview__label">
                              {t("Term months")}
                            </span>
                            <div className="deposit-order-preview__choice-row">
                              {terms.map((term) => (
                                <button
                                  className={`deposit-order-preview__choice ${selectedPeriod === term.term ? "deposit-order-preview__choice--selected" : ""}`}
                                  key={term.term}
                                  type="button"
                                  onClick={() => this.selectPeriod(term.term)}
                                >
                                  {term.label}
                                </button>
                              ))}
                            </div>
                          </div>
                          <div className="deposit-order-preview__choice-box">
                            <span className="deposit-order-preview__label">
                              {t("currency")}
                            </span>
                            <div className="deposit-order-preview__choice-row">
                              <button
                                className="deposit-order-preview__choice deposit-order-preview__currency deposit-order-preview__choice--selected"
                                type="button"
                              >
                                {selectedAccount?.currName || "-"}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="deposit-order-preview__choice-box deposit-order-preview__frequency">
                          <span className="deposit-order-preview__label">
                            {t("Interest payment frequency")}
                          </span>
                          <div className="deposit-order-preview__choice-row">
                            {availableFrequencies.map((frequency, index) => (
                              <button
                                className={`deposit-order-preview__choice ${selectedDepositIndex === index ? "deposit-order-preview__choice--selected" : ""}`}
                                key={frequency.depSettProductId}
                                type="button"
                                onClick={() => this.selectFrequency(index)}
                              >
                                {frequency.name}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="deposit-order-preview__notice">
                          <span className="deposit-order-preview__notice-icon">
                            i
                          </span>
                          <span>
                            <strong>
                              {selectedProduct?.productName || t("deposit")}
                            </strong>
                            {result
                              ? `${t("interest income")}: ${result.percentAmount} · ${t("Bonus amount")}: ${result.bonusAmount} · ${t("Final amount")}: ${result.totalAmount}`
                              : selectedDepositIndex >= 0
                                ? `${t("interest rate")}: ${selectedFrequency?.rate}% · 
                                ${selectedProductIndex === 0 ? `${t("Amount")}: ${selectedFrequency?.minAmount} - ${selectedFrequency?.maxAmount}` : `${t("Min amount allowed")}: ${selectedFrequency?.minAmount}`}`
                                : t("Select all fields to calculate")}
                          </span>
                        </div>
                      </div>
                        <button
                          className="deposit-order-preview__submit"
                          type="button"
                          disabled={!canCalculate || isCalculating}
                          onClick={this.calculate}
                        >
                          {isCalculating ? t("Calculating") : t("Calculate")}
                        </button></>}
                    </section>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default translate("translation")(DepositOrder);